import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { Box } from "@mui/material";
import PropTypes from 'prop-types';
import { useEffect } from "react";

import { useQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import { useSoftUIController } from "hooks/context";

import bksAPI from 'services/api/bks';
import inspectionAPI from 'modules/inspections/api';

import { processDevicesData } from "utils/device";
import { wrapper, loadingScreen } from "utils/wrapper";
import { disableMap } from "utils/map";

import CreateInspection from "pages/components/Operations/CreateInspection";

function NewInspectionView({ map, user }) {
    const [controller] = useSoftUIController();
    const { deviceLayout, selectedOrg } = controller;

    useEffect(() => {
        if (!map.current) return;
        disableMap(map, user, selectedOrg);
    }, [selectedOrg]);

    // Queries
    bksAPI.loadToken(useAuth0());
    inspectionAPI.loadToken(useAuth0());

    const navigate = useNavigate();
    const location = useLocation();

    const { currentDevice } = location.state || {};

    const devices = useQuery({
        queryKey: ['getAllDevices', selectedOrg],
        queryFn: async () => await bksAPI.getAllDevices(),
        refetchInterval: 300 * 1000,
        refetchIntervalInBackground: true,
    });

    const maintenance_tags = useQuery({
        queryKey: ['getAllMaintenanceTags', selectedOrg],
        queryFn: async () => {
            return await inspectionAPI.getAllMaintenanceTags();
        }
    });

    const all_inspections = useQuery({
        queryKey: ['getAllInspectionsForUser', user, selectedOrg],
        queryFn: async () => {
            return await inspectionAPI.getAllInspectionsForUser(user);
        }
    });

    if (devices.isLoading) {
        return loadingScreen(controller, true);
    }

    if (devices.error || maintenance_tags.error) {
        return wrapper((
            <SoftBox p={3} lineHeight={1}>
                <SoftTypography variant="h5" fontWeight="medium">
                    {"An error has occurred: " + (devices?.error?.message || maintenance_tags?.error?.message)}
                </SoftTypography>
            </SoftBox>
        ), controller, true);
    }

    const devices_data = processDevicesData(devices.dataUpdatedAt, devices.data, true);

    return wrapper((
        <Box display="flex" justifyContent="center" height={deviceLayout == 'mobile' ? "100%" : "unset"} sx={{ p: deviceLayout == 'mobile' ? 0 : 5 }}>
            <SoftBox sx={{ width: "100%", maxWidth: "1400px" }}>
                <CreateInspection selected_user={user} all_devices={devices_data} maintenance_tags={maintenance_tags.data} selected_device={currentDevice?.organisation_id == selectedOrg ? currentDevice : null} all_inspections={all_inspections.data?.inspections} />
            </SoftBox>
        </Box>
    ), controller, true);
}

NewInspectionView.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object
}

export default NewInspectionView;
